// extracted by mini-css-extract-plugin
module.exports =  {"dialogContainer":"dialogContainer__QdX2Q","borders":"borders__hwPDe"};